<div id="check-{{name}}" class="checkbox d-flex" appClickable (click)="toggle()">
  <div class="check" [class.checked]="check"></div>
  <span class="align-top text-validate">{{ message }}</span>
</div>
